class EventBus extends EventTarget {}

// Export a singleton instance
const eventBus = new EventBus();
export default eventBus;
